import { render, staticRenderFns } from "./finish_details.vue?vue&type=template&id=ec943224&scoped=true&"
import script from "./finish_details.vue?vue&type=script&lang=js&"
export * from "./finish_details.vue?vue&type=script&lang=js&"
import style0 from "./finish_details.vue?vue&type=style&index=0&id=ec943224&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec943224",
  null
  
)

export default component.exports